import type { FC } from 'react'
import {
	Box,
	ColumnLayout,
	Container,
	Header,
	SpaceBetween
} from '@cloudscape-design/components'
import type { MongoDBDetails } from '../../../types/mongodb'

interface ClusterSummaryProps {
	cluster: MongoDBDetails['cluster']
}

const ClusterSummary: FC<ClusterSummaryProps> = ({ cluster }) => (
	<Container
		header={<Header variant="h2">MongoDB Cluster Configuration</Header>}
	>
		<SpaceBetween direction="vertical" size="s">
			<Header variant="h3">{cluster.name}</Header>
			<ColumnLayout columns={2} variant="text-grid">
				{[
					['Cluster type', cluster.cluster_type],
					['MongoDB version', cluster.mongodb_major_version],
					['Instance size', cluster.instance_size],
					['Node count', cluster.node_count],
					['Disk size (GB)', cluster.disk_size_gb],
					[
						'Compute autoscaling',
						cluster.auto_scaling_compute_enabled ? 'Enabled' : 'Disabled'
					],
					...(cluster.auto_scaling_compute_enabled
						? [
								[
									'Minimum instance size',
									cluster.auto_scaling_compute_min_instance_size
								],
								[
									'Maximum instance size',
									cluster.auto_scaling_compute_max_instance_size
								]
						  ]
						: [])
				].map(([label, value]) => (
					<div key={label}>
						<Box variant="awsui-key-label">{label}</Box>
						<Box>{value ?? '-'}</Box>
					</div>
				))}
			</ColumnLayout>
		</SpaceBetween>
	</Container>
)

export default ClusterSummary
